module.exports = "<div *ngIf=\"loading\" class=\"loading-tag\">\n  <img src=\"assets/images/loading-icon.svg\" style=\"position: absolute;\">\n</div>"